export default [
  {
    path: '/h5/diamond-racing',
    component: () => import('./Index.vue'),
    meta: { title: '钻石竞速' },
  },
]
